import { gql } from "gql";

export const EXTERNAL_SIGN_REGISTRATION_SIGNED_SUBSCRIPTION = gql(
  /* GraphQL */ `
    subscription ExternalSignRegistrationSignedSubscription($code: String!) {
      externalSignRegistrationStatusSubscription(code: $code)
    }
  `,
);
